

module.exports = __webpack_require__.stylable.create(
    "TpaModal3660552826",
    {"classes":{"root":"TpaModal3660552826__root","modal":"TpaModal3660552826__modal","overlay":"TpaModal3660552826__overlay","closeButton":"TpaModal3660552826__closeButton"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "TpaModal3660552826",
    null
);
